<div class="navigation-controls">
  <div class="controls-container">
    <!-- Zoom Controls -->
    <div class="controls">
      <button
        class="nav-button"
        (click)="fitToScreen()"
        [title]="'navigationControls.fitToScreen' | transloco"
        [attr.aria-label]="'navigationControls.fitToScreen' | transloco"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
          />
        </svg>
      </button>

      <button
        class="nav-button"
        (click)="zoomIn()"
        [title]="'navigationControls.zoomIn' | transloco"
        [attr.aria-label]="'navigationControls.zoomIn' | transloco"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
          <line x1="11" y1="8" x2="11" y2="14" />
          <line x1="8" y1="11" x2="14" y2="11" />
        </svg>
      </button>
      <button
        class="nav-button"
        (click)="zoomOut()"
        [title]="'navigationControls.zoomOut' | transloco"
        [attr.aria-label]="'navigationControls.zoomOut' | transloco"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
          <line x1="8" y1="11" x2="14" y2="11" />
        </svg>
      </button>
    </div>

    <!-- Tilt Controls -->
    <div class="controls">
      <button
        class="nav-button"
        (click)="tiltUp()"
        [title]="'navigationControls.tiltUp' | transloco"
        [attr.aria-label]="'navigationControls.tiltUp' | transloco"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="18 15 12 9 6 15" />
          <polyline points="18 20 12 14 6 20" />
        </svg>
      </button>
      <button
        class="nav-button"
        (click)="tiltDown()"
        [title]="'navigationControls.tiltDown' | transloco"
        [attr.aria-label]="'navigationControls.tiltDown' | transloco"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="6 9 12 15 18 9" />
          <polyline points="6 4 12 10 18 4" />
        </svg>
      </button>
    </div>

    <!-- Rotation Controls -->
    <div class="controls">
      <button
        class="nav-button"
        (click)="rotateCounterClockwise()"
        [title]="'navigationControls.rotateCounterClockwise' | transloco"
        [attr.aria-label]="'navigationControls.rotateCounterClockwise' | transloco"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
        </svg>
      </button>
      <button
        class="nav-button"
        (click)="rotateClockwise()"
        [title]="'navigationControls.rotateClockwise' | transloco"
        [attr.aria-label]="'navigationControls.rotateClockwise' | transloco"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
          <path d="M21 3v5h-5" />
        </svg>
      </button>
    </div>

    <div class="controls">
      <!-- Navigation Button -->
      <button
        class="nav-button"
        [class.active]="showNavigation()"
        (click)="toggleNavigation()"
        [title]="'navigationControls.navigationMode' | transloco"
        [attr.aria-label]="'navigationControls.navigationMode' | transloco"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polygon points="3 11 22 2 13 21 11 13 3 11" />
        </svg>
      </button>

      <!-- View Presets Button -->
      <button
        class="nav-button"
        [class.active]="showViewPresets()"
        (click)="toggleViewPresets()"
        [title]="'navigationControls.viewPresets' | transloco"
        [attr.aria-label]="'navigationControls.viewPresets' | transloco"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
        </svg>
      </button>

      <!-- Help Button -->
      <button
        class="nav-button"
        (click)="toggleHelp()"
        [title]="'navigationControls.navigationHelp' | transloco"
        [attr.aria-label]="'navigationControls.navigationHelp' | transloco"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <circle cx="12" cy="17" r="0.5" fill="currentColor" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Help Panel -->
  @if (showHelp()) {
    <div class="help-panel">
      <div class="help-header">
        <h3>{{ 'navigationControls.helpTitle' | transloco }}</h3>
        <button
          class="close-button"
          (click)="toggleHelp()"
          [attr.aria-label]="'navigationControls.closeHelp' | transloco"
        >
          ×
        </button>
      </div>
      <div class="help-content">
        <ul>
          <li>
            <strong>{{ 'navigationControls.leftClickDrag' | transloco }}</strong>
            {{ 'navigationControls.leftClickDragDesc' | transloco }}
          </li>
          <li>
            <strong>{{ 'navigationControls.rightClickDrag' | transloco }}</strong>
            {{ 'navigationControls.rightClickDragDesc' | transloco }}
          </li>
          <li>
            <strong>{{ 'navigationControls.scrollWheel' | transloco }}</strong>
            {{ 'navigationControls.scrollWheelDesc' | transloco }}
          </li>
          <li>
            <strong>{{ 'navigationControls.middleClickDrag' | transloco }}</strong>
            {{ 'navigationControls.middleClickDragDesc' | transloco }}
          </li>
        </ul>
      </div>
    </div>
  }

  <!-- Navigation Mode Panel -->
  @if (showNavigation()) {
    <div class="help-panel">
      <div class="help-header">
        <h3>{{ 'navigationControls.navigationMode' | transloco }}</h3>
        <button
          class="close-button"
          (click)="toggleNavigation()"
          [attr.aria-label]="'navigationControls.closeNavigation' | transloco"
        >
          ×
        </button>
      </div>
      <div class="help-content">
        <div class="nav-setting">
          <app-dropdown
            [value]="currentNavigationMode"
            [options]="navigationModeOptions"
            (valueChange)="onNavigationModeChange($event)"
            width="100%"
          ></app-dropdown>
        </div>
      </div>
    </div>
  }

  <!-- View Presets Panel -->
  @if (showViewPresets()) {
    <div class="help-panel">
      <div class="help-header">
        <h3>{{ 'navigationControls.viewPresets' | transloco }}</h3>
        <button
          class="close-button"
          (click)="toggleViewPresets()"
          [attr.aria-label]="'navigationControls.closeViewPresets' | transloco"
        >
          ×
        </button>
      </div>
      <div class="help-content">
        <div class="view-preset-grid">
          <app-button (click)="fitToScreen()" variant="secondary">
            {{ 'navigationControls.fit' | transloco }}
          </app-button>
          <app-button (click)="setTopView()" variant="secondary">
            {{ 'navigationControls.top' | transloco }}
          </app-button>
          <app-button (click)="setBottomView()" variant="secondary">
            {{ 'navigationControls.bottom' | transloco }}
          </app-button>
          <app-button (click)="setFrontView()" variant="secondary">
            {{ 'navigationControls.front' | transloco }}
          </app-button>
          <app-button (click)="setBackView()" variant="secondary">
            {{ 'navigationControls.back' | transloco }}
          </app-button>
          <app-button (click)="setLeftView()" variant="secondary">
            {{ 'navigationControls.left' | transloco }}
          </app-button>
          <app-button (click)="setRightView()" variant="secondary">
            {{ 'navigationControls.right' | transloco }}
          </app-button>
        </div>
      </div>
    </div>
  }
</div>
